import { useLocation } from "react-router-dom";
import defaultImage from "../assets/images/default-image.png";
import { Link } from "react-router-dom";
import { Routers } from "../routes/Constant";
import { LeftBlackArrow } from "../assets/icons/LeftBlackArrow";

export const InstructorDetail = () => {
  const location = useLocation();
  const { myData } = location.state || {}; // Safe fallback if no state passed

  console.log(myData); // Your passed data

  return (
    <div class="container">
      <Link to={Routers.Manual} className="back_Link text-dark mt-5 d-flex align-items-center"><LeftBlackArrow/> {"Back"}</Link>
      <div class="aboutInstructor_section">
        <h2
          style={{
            fontSize: "40px",
            fontWeight: 700,
            textAlign: "center",
            marginBottom: "60px",
          }}
        >
          Instructor Profile
        </h2>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-10 col-lg-6 col-xl-5 mb-sm-3 mb-lg-0">
              <div
                style={{
                  background: "#4d2ec90d",
                  borderRadius: "12px",
                  textAlign: "center",
                  padding: "10px",
                  boxShadow:
                    "rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em",
                }}
              >
                <img
                  src={
                     myData.profile_image ? "https://keyzi.com.au/keyzi-admin/public/" + myData.profile_image : defaultImage
                  }
                  alt={myData.name}
                  style={{
                    width: "150px",
                    height: "150px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    margin: "15px",
                  }}
                />
                <div className="container" style={{ textAlign: "left" }}>
                  <div className="row border-bottom py-2">
                    <div className="col-5">
                      <strong>Full Name:</strong>
                    </div>
                    <div className="col">
                      {[myData.name, myData.middle_name, myData.last_name]
                        .filter(Boolean)
                        .join(' ')}
                    </div>
                  </div>
                  <div className="row border-bottom py-2">
                    <div className="col-5">
                      <strong>Email:</strong>
                    </div>
                    <div className="col">{myData.email}</div>
                  </div>
                  <div className="row border-bottom py-2">
                    <div className="col-5">
                      <strong>Phone:</strong>
                    </div>
                    <div className="col">{myData.phone}</div>
                  </div>
                  <div className="row border-bottom py-2">
                    <div className="col-5">
                      <strong>Username:</strong>
                    </div>
                    <div className="col">{myData.username}</div>
                  </div>
                  <div className="row border-bottom py-2">
                    <div className="col-5">
                      <strong>Gender:</strong>
                    </div>
                    <div className="col">{myData.gender}</div>
                  </div>
                  <div className="row py-2">
                    <div className="col-5">
                      <strong>Date of Birth:</strong>
                    </div>
                    <div className="col">{myData.date_of_birth}</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-10 col-lg-6 col-xl-5">
              <div
                style={{
                  background: "#4d2ec90d",
                  borderRadius: "12px",
                  textAlign: "left",
                  padding: "10px",
                  boxShadow:
                    "rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em",
                }}
              >
                <div className="container">
                  <div className="row border-bottom py-2">
                    <div className="col-5">
                      <strong>Status:</strong>
                    </div>
                    <div className="col">{myData.status}</div>
                  </div>
                  <div className="row border-bottom py-2">
                    <div className="col-5">
                      <strong>Address:</strong>
                    </div>
                    <div className="col">{myData.address}</div>
                  </div>
                  <div className="row border-bottom py-2">
                    <div className="col-5">
                      <strong>Qualification:</strong>
                    </div>
                    <div className="col">{myData.qualification}</div>
                  </div>
                  <div className="row border-bottom py-2">
                    <div className="col-5">
                      <strong>Vehicle Name:</strong>
                    </div>
                    <div className="col">{myData.vehicle_name}</div>
                  </div>
                  <div className="row border-bottom py-2">
                    <div className="col-5">
                      <strong>Transmission Type:</strong>
                    </div>
                    <div className="col">{myData.transmission_type}</div>
                  </div>
                  <div className="row border-bottom py-2">
                    <div className="col-5">
                      <strong>Experience:</strong>
                    </div>
                    <div className="col">{myData.experience} Year(s)</div>
                  </div>
                  <div className="row border-bottom py-2">
                    <div className="col-5">
                      <strong>Rating:</strong>
                    </div>
                    <div className="col">{myData.rating}</div>
                  </div>
                  <div className="row border-bottom py-2">
                    <div className="col-5">
                      <strong>Licence Number:</strong>
                    </div>
                    <div className="col">{myData.licence_number}</div>
                  </div>
                  <div className="row border-bottom py-2">
                    <div className="col-5">
                      <strong>Licence Expiry:</strong>
                    </div>
                    <div className="col">{myData.licence_expiry_date}</div>
                  </div>
                  <div className="row py-2">
                    <div className="col-5">
                      <strong>Driving Licence:</strong>
                    </div>
                    <div className="col">
                      {myData.driving_licence ? (
                        <img
                          src={myData.driving_licence}
                          alt="Driving Licence"
                          style={{
                            width: "100%",
                            maxWidth: "300px",
                            borderRadius: "10px",
                          }}
                        />
                      ) : (
                        <p className="mb-0">No licence uploaded.</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
